type StringMap = {
  [key: string]: string
}

type NestedObject = {
  [key: string]: { [key: string]: string }
}

type StyleObject = Partial<CSSStyleDeclaration>

type NestedArrayObject = {
  fontSize: { [key: string]: [string, StyleObject] }
  fontWeight: { [key: string]: string }
}

let colorMap: NestedObject
let borderRadius: StringMap
let textMap: NestedArrayObject
let boxShadow: StringMap

const COLORS = [
  // PRIMARY
  'brand-1',
  'brand-2',
  'brand-3',
  'brand-4',
  'brand-5',
  'brand-6',
  'brand-7',
  'brand-8',
  'brand-9',
  'brand-10',
  // ERROR
  'error-1',
  'error-2',
  'error-3',
  'error-4',
  'error-5',
  'error-6',
  'error-7',
  'error-8',
  'error-9',
  'error-10',
  // SUCCESS
  'success-1',
  'success-2',
  'success-3',
  'success-4',
  'success-5',
  'success-6',
  'success-7',
  'success-8',
  'success-9',
  'success-10',
  // WARNING
  'warning-1',
  'warning-2',
  'warning-3',
  'warning-4',
  'warning-5',
  'warning-6',
  'warning-7',
  'warning-8',
  'warning-9',
  'warning-10',
  // WHITE
  'white-1',
  // GRAY
  'gray-1',
  'gray-2',
  'gray-3',
  'gray-4',
  'gray-5',
  'gray-6',
  'gray-7',
  'gray-8',
  'gray-9',
  'gray-10',
  'gray-11',
  'gray-12',
  'gray-13',
  'gray-14',
]
const TEXT_COLORS = [
  'gray-1',
  'gray-2',
  'gray-3',
  'gray-4',
  'white-1',
  'white-2',
  'white-3',
  'white-4',
]
const FONT_SIZE = ['lg', 'md', 'xl', 'base', 'sm', 'xs', 'mini', 't', 'm']
const COLORS_MAIN = ['primary', 'success', 'danger', 'warning']
const COLORS_STATUS_MAIN = [
  'active',
  'disabled',
  'focus',
  'light',
  'light-active',
]
const FONT_WEIGHT = ['r', 'm', 'sb']
const BORDER_RADIUS = ['sm', 'md', 'lg', 'xl', 'round', 'circle']
const BOX_SHADOW = ['base', 'md', 'top']

/**
 * 字体大小
 */
textMap = {
  fontSize: {},
  fontWeight: {},
}
FONT_SIZE.forEach((prev) => {
  textMap.fontSize[prev] = [
    `var(--xzx-text-${prev})`,
    { lineHeight: `var(--xzx-text-lh-${prev})` },
  ]
})
FONT_WEIGHT.forEach((prev) => {
  textMap.fontWeight[prev] = `var(--xzx-text-w-${prev})`
})

/**
 * 颜色
 */
colorMap = {
  colors: {},
  textColor: {},
}
COLORS_MAIN.forEach((prev) => {
  colorMap.colors[prev] = colorMap.textColor[prev] = `var(--xzx-color-${prev})`
  COLORS_STATUS_MAIN.forEach((_prev) => {
    colorMap.colors[`${prev}-${_prev}`] = colorMap.textColor[
      `${prev}-${_prev}`
    ] = `var(--xzx-color-${prev}-${_prev})`
  })
})

/**
 * 文字颜色
 */
TEXT_COLORS.forEach((prev) => {
  colorMap.textColor[prev] = `var(--xzx-text-${prev})`
})

/**
 * 其他颜色
 */
COLORS.forEach((prev) => {
  colorMap.colors[prev] = `var(--xzx-${prev})`
})

borderRadius = {}
BORDER_RADIUS.forEach((prev) => {
  borderRadius[prev] = `var(--xzx-br-${prev})`
})

boxShadow = {}
BOX_SHADOW.forEach((prev) => {
  boxShadow[prev] = `var(--xzx-shadow-${prev})`
})

export const themeExtend = {
  colors: colorMap.colors,
  textColor: colorMap.textColor,
  fontSize: textMap.fontSize,
  fontWeight: textMap.fontWeight,
  borderRadius,
  boxShadow,
}
